import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SelectButton } from 'primereact/selectbutton';
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import { Button } from 'semantic-ui-react';

import classes from 'app/components/Modal/classes.module.scss';

const ImageSelectList = ({ isOpen, onClose, assetType, selectCallback }) => {

  const darkMode = useSelector(state => state.portalReducer.darkMode);
  const user = useSelector(state => state.userReducer.user);
  const backgrounds = useSelector(state => state.knockOutReducer.backgrounds);
  const overlays = useSelector(state => state.knockOutReducer.overlays);

  const [data, setData] = useState([]);
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (assetType === 'bg') {
      setData(backgrounds);
    } else {
      setData(overlays);
    }
  }, [assetType])

  const modalStyle = {};

  modalStyle.justifyContent = 'end';
  modalStyle.marginRight = '1.5rem';

  let boxClass = classes.paper,
    boxStyle = null,
    headerVariant = 'h5';

  let header = assetType === 'bg' ? 'Select a Background' : 'Select an Overlay';

  const optionTemplate = (option) => {
    return <div className="flex align-items-center">
      <img alt={option.name} src={option.url} style={{ height: '80px' }} />
    </div>
  };

  return <Modal open={isOpen} className={classes.modal} onClose={onClose}>
    <Box className={boxClass} style={boxStyle}>
      <CloseIcon className={classes.closeIcon} onClick={onClose} />
      <Typography variant={headerVariant} className={classes.formTitle}>
        {header}
      </Typography>
      <hr />
      <SelectButton value={value} onChange={(e) => setValue(e.value)} itemTemplate={optionTemplate} options={data} />
      <hr />
      <Button basic primary floated='right' onClick={() => selectCallback(value)}>Select</Button>
    </Box>
  </Modal>
}

export default ImageSelectList;
